export default {
  firstNameInputLabel: 'First Name',
  lastNameInputLabel: 'Last Name',
  resetButtonLabel: 'RESET',
  submitButtonLabel: 'SAVE'
};
